import React from 'react';
import window from 'global';
import EmailModalComponent from '../components/EmailModal';
import { Header, NavBrand, Box } from 'tailwind-react-ui';

const HeaderComponent = () => {

  window.onscroll = function() {
    if(window.pageYOffset === 0) {
      if (!toggle){
        setBg('transparent');
      }
    }else{
      setBg('dark-purple');
    }
    if (window.pageYOffset >= window.innerHeight-80){
      setActiveBtn(true);
    }else{
      setActiveBtn(false);
    }
  };

  function handeClick(){
    setToggle(!toggle);
    if (window.pageYOffset === 0){
      if (!toggle){
        setBg('dark-purple');
      }else{
        setBg('transparent');
      }
    }
  }

  function onItemClick(id){
    window.scrollTo(0, document.getElementById(id).offsetTop-80);
    setToggle(false);
  }

  function onBrandClick(){
    window.scrollTo(0, 0);
    setToggle(false);
  }

  const [showModal, setShowModal] = React.useState(false);
  const [toggle, setToggle] = React.useState(false); 
  const [bg, setBg] = React.useState('transparent');
  const [activeBtn, setActiveBtn] = React.useState(false);
  const menu = React.useRef(null);
  var bgActiveBtn = activeBtn ? ' bg-yellow' : '';
  var textActiveBtn = activeBtn ? ' text-dark-purple' : '';
  const navItemDefClass = 'quicksand-bold cursor-pointer block mt-4 lg:inline-block lg:mt-0 text-teal-200 lg:mx-4 px-4 py-1 no-underline ';
  const navItemHocusClass = 'border-transparent border-b-2 hover:border-white focus:border-white ';
  const navItemClass = navItemDefClass + navItemHocusClass;
  const mainNavItemClass = 'rounded py-2 hover:bg-yellow focus:bg-yellow hover:text-dark-purple focus:text-dark-purple ' + navItemDefClass  + bgActiveBtn + textActiveBtn;

  return (
    <Header bg={bg} text={'white'} h={'80'} z={'40'} fixed w={'screen'}>
      <NavBrand is="a" href="javascript:void(0);" className="focus:shadow-none" onClick={onBrandClick}>
        <Box
          is="img"
          width="180"
          height="32"
          alt="sixtynite"
          src="https://storage.googleapis.com/assets-sixtynite-com/chelas-gratis/logotipo-sixtynite.png"
        />
      </NavBrand>
      <div className="inline-block lg:hidden">
          <button onClick={handeClick} className="flex items-center px-3 py-2 border rounded text-teal-200 border-teal-400 hover:text-white hover:border-white">
            <svg className="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/></svg>
          </button>
        </div>
      <nav className="flex items-center justify-between flex-wrap w-full lg:w-auto bg-teal-500">
        <div 
          ref={menu} 
          style={
            toggle
            ? {
                transition: 'max-height 500ms, backgroundColor 500ms',
                maxHeight: '100vh'
              }
            : undefined
          }
          className="w-full block flex-grow lg:flex lg:items-center lg:w-auto max-h-0 lg:max-h-screen overflow-hidden">
          <div className="text-sm lg:flex-grow">
            <a onClick={() => onItemClick('como-funciona')} className={navItemClass}>
              ¿CÓMO FUNCIONA?
            </a>
            <a onClick={() => onItemClick('moteles-participantes')} className={navItemClass}>
              MOTELES PARTICIPANTES
            </a>
            <a onClick={() => onItemClick('compartir-cupon')} className={navItemClass}>
              COMPARTIR CUPÓN
            </a>
            <a onClick={() => setShowModal(true)} className={mainNavItemClass}>
              LO QUIERO
            </a>
          </div>
        </div>
      </nav>
      <EmailModalComponent showModal={showModal} setShowModal={(show) => setShowModal(show)}/>
    </Header>
    );
};

export default HeaderComponent;

